import { useEffect } from "react";

const Pagination = ({
  totalPosts,
  postsPerPage,
  setCurrentPage,
  currentPage,
  setPageQuery,
}) => {
  const totalPages = Math.max(1, Math.ceil((totalPosts || 0) / postsPerPage));
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  useEffect(() => {
    if (typeof setPageQuery === "function") {
      setPageQuery(`&page_number=${currentPage}`);
    }
  }, [currentPage, setPageQuery]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    } else if (currentPage < 1) {
      setCurrentPage(1);
    }
  }, [currentPage, totalPages, setCurrentPage]);

  if (!totalPosts || totalPosts <= 0) {
    return null;
  }

  return (
    <div className="font-jt flex flex-wrap justify-center w-full my-4">
      <>
        <button
          type="button"
          disabled={currentPage <= 1}
          className={`px-2 py-1 font-semibold rounded-full transition-all duration-300 bg-transparent text-black border-black mx-1 ${
            currentPage <= 1 ? "opacity-40 cursor-not-allowed" : "cursor-pointer"
          }`}
          onClick={() => {
            if (currentPage > 1) {
              setCurrentPage(currentPage - 1);
            }
          }}
        >
          {"← Previous"}
        </button>
        {pages.map((page) => {
          return (
            <button
              type="button"
              key={page}
              onClick={() => setCurrentPage(page)}
              className={`w-10 h-10 font-semibold rounded-full cursor-pointer transition-all duration-300 mx-1 ${
                page === currentPage
                  ? "font-black bg-[#ECECEC] text-black "
                  : "bg-transparent text-black border-black"
              }`}
            >
              {page}
            </button>
          );
        })}
        <button
          type="button"
          disabled={currentPage >= totalPages}
          className={`px-10 py-2 font-semibold rounded-lg transition-all duration-300 text-white bg-black border-black mx-1 ${
            currentPage >= totalPages
              ? "opacity-40 cursor-not-allowed"
              : "cursor-pointer"
          }`}
          onClick={() => {
            if (currentPage < totalPages) {
              setCurrentPage(currentPage + 1);
            }
          }}
        >
          {"Next →"}
        </button>
      </>
    </div>
  );
};

export default Pagination;
